/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempEditorWrapText: {
  name: 'temp-editor-wrap-text';
  data: string;
} = {
  name: 'temp-editor-wrap-text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a1 1 0 0 0 0 2h13a1 1 0 1 0 0-2H5Zm-1 7a1 1 0 0 1 1-1h11a4 4 0 0 1 0 8h-.586l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H16a2 2 0 1 0 0-4H5a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
